import React from 'react';

import { Card } from '@xing-com/card';
import { Link } from '@xing-com/crate-components-link';

import { ArticleCardFooter } from './article-card-footer';
import { ArticleCardHeader } from './article-card-header';
import { Styled } from './article-card.styles';

export type ArticleCardType = {
  description: string;
  imageSrc?: string;
  pageTitle: string;
  profileImage: string;
  title: string;
  url: string;
};

export const ArticleCard: React.FC<ArticleCardType> = ({
  description,
  imageSrc,
  pageTitle,
  profileImage,
  title,
  url,
}) => {
  const [hasError, setHasError] = React.useState(false);
  const urlWithoutTracking = url.split('?')[0];

  const handleAnchorClick = (e: React.MouseEvent): void => {
    e.preventDefault();

    window.location.assign(url);
  };

  return (
    <Card noPadding>
      <Link href={urlWithoutTracking} onClick={handleAnchorClick}>
        <ArticleCardHeader {...{ pageTitle, profileImage }} />
        {imageSrc && !hasError ? (
          <Styled.Image
            data-qa="article-card-image"
            src={imageSrc}
            alt={`${title}-article-image`}
            // @ts-expect-error FIXME: SC6
            loading="lazy"
            onError={() => setHasError(true)}
          />
        ) : (
          <Styled.FallbackImage />
        )}
        <ArticleCardFooter {...{ description, title }} />
      </Link>
    </Card>
  );
};
